interface MapLocationNameToAlgolia {
  (locationTitle: string): string
}

const mapLocationNameToAlgolia: MapLocationNameToAlgolia = (locationTitle) => {
  switch (locationTitle) {
    case 'New York State':
      return 'New York'
    case 'New York':
      return 'New York City'
    default:
      return locationTitle
  }
}

export default mapLocationNameToAlgolia
